// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-history-view {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  width: 100%;
}

.payment-history-view__header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
}

.payment-history-view__back {
  margin: 0 0 0.55rem;
  padding: 0.45rem 0.75rem;
  border: 1px solid rgba(31, 27, 46, 0.14);
  border-radius: 10px;
  background: #fff;
  color: #2c3140;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.payment-history-view__back:hover {
  background: #f7f7f9;
  border-color: rgba(31, 27, 46, 0.28);
}

.payment-history-view__eyebrow {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #6f7588;
}

.payment-history-view__title {
  margin: 0;
  font-family: "Merriweather", Georgia, serif;
  font-size: clamp(1.65rem, 3vw, 2.1rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.15;
  color: #1f1b2e;
}

.payment-history-view__panel {
  width: 100%;
  padding: 1.25rem 1.35rem 1.5rem;
  border: 1px solid rgba(31, 27, 46, 0.12);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(52, 62, 94, 0.05);
}

.payment-history-view__empty {
  margin: 0;
  padding: 1.25rem 1.1rem;
  border-radius: 12px;
  border: 1px dashed rgba(143, 155, 175, 0.35);
  background: #fafafa;
  color: #6f7588;
  font-size: 0.95rem;
}

@media (max-width: 720px) {
  .payment-history-view__panel {
    padding: 1rem;
    border-radius: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PaymentHistoryView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF","sourcesContent":[".payment-history-view {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  width: 100%;\n}\n\n.payment-history-view__header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.35rem;\n}\n\n.payment-history-view__back {\n  margin: 0 0 0.55rem;\n  padding: 0.45rem 0.75rem;\n  border: 1px solid rgba(31, 27, 46, 0.14);\n  border-radius: 10px;\n  background: #fff;\n  color: #2c3140;\n  font-size: 0.88rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.payment-history-view__back:hover {\n  background: #f7f7f9;\n  border-color: rgba(31, 27, 46, 0.28);\n}\n\n.payment-history-view__eyebrow {\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #6f7588;\n}\n\n.payment-history-view__title {\n  margin: 0;\n  font-family: \"Merriweather\", Georgia, serif;\n  font-size: clamp(1.65rem, 3vw, 2.1rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n  color: #1f1b2e;\n}\n\n.payment-history-view__panel {\n  width: 100%;\n  padding: 1.25rem 1.35rem 1.5rem;\n  border: 1px solid rgba(31, 27, 46, 0.12);\n  border-radius: 18px;\n  background: #fff;\n  box-shadow: 0 10px 24px rgba(52, 62, 94, 0.05);\n}\n\n.payment-history-view__empty {\n  margin: 0;\n  padding: 1.25rem 1.1rem;\n  border-radius: 12px;\n  border: 1px dashed rgba(143, 155, 175, 0.35);\n  background: #fafafa;\n  color: #6f7588;\n  font-size: 0.95rem;\n}\n\n@media (max-width: 720px) {\n  .payment-history-view__panel {\n    padding: 1rem;\n    border-radius: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
